import React, { useState, useCallback } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  deDetailList,
  addDeDetail,
  detailDbSettingDetail,
  deDetailUseYn,
  deDetailEdit,
  dbSettingDetailDelete,
} from 'lib/api/server';
import { dataConverter } from 'lib/commonLib';
import { showSuccessSnackbar } from 'modules/snackbar';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';

const DbSettingDetail = ({ location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const convertKeys = ['sysId', 'cdId', 'uri'];
  let initParams = {};
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };
  //const [params] = useState(initParams);
  const initModal = {
    open: false,
    type: null,
    params: {
      sysId: '',
      cdId: '',
      cdDetailId: '',
    },
    modalTitle: '',
    confirmBtnTitle: '',
  };
  const [modal, setModal] = useState(initModal);
  const [error, setError] = useState({});
  const [reFetch, setReFetch] = useState(false);

  const [params, setParams] = useState(initParams);

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 모달 값을 변경하는 함수
   * @param newParams
   * @param name
   */
  const modalGetParam = (newParams, name) => {
    let newError = { ...error };
    if (name === 'cdDetailId') {
      if (!newParams[name]) {
        newError = {
          cdDetailId: true,
        };
      } else {
        delete newError[[name]];
      }
      setError(newError);
    }
    setModal({
      ...modal,
      params: {
        ...newParams,
      },
    });
  };
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <NewButton
              name="edit"
              title={t('수정')}
              iconBtn
              icon="faEdit"
              onClick={(e) => handleModalOpen(e, data)}
              disableRipple
            />
            <NewButton
              name="delete"
              title={t('삭제')}
              iconBtn
              icon="faTrashAlt"
              onClick={(e) => handleModalOpen(e, data)}
              disableRipple
            />
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  const customized = {
    MANAGE_ICONS: {
      headStyle: {
        width: 70,
      },
    },
    USE_YN: {
      makeBody: (rowObj, headsMap) => {
        return (
          <NewButton
            title={t('사용여부 on/off')}
            icon="faPowerOff"
            iconBtn
            onClick={() => handleStateToggle(rowObj)}
            style={rowObj.USE_YN === '01' ? { backgroundColor: '#79bd2f' } : {}}
            color={rowObj.USE_YN === '01' ? '#fff' : undefined}
          />
        );
      },
      headStyle: {
        width: 100,
      },
    },
    CD_KEY: {
      bodyStyle: {
        width: 300,
        wordBreak: 'break-all',
      },
    },
  };

  const handleStateToggle = (rowData) => {
    const newParams = {
      sysId: rowData['SYS_ID'],
      cdId: rowData['CD_ID'],
      cdDetailId: rowData['CD_DETAIL_ID'],
      useYn: rowData['USE_YN'] === '01' ? '02' : '01',
    };
    deDetailUseYn(newParams)
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({
          message: message,
          option: {
            type: 'success',
          },
        });
        setReFetch(true);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        setReFetch(false);
      });
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e, data) => {
    const { name } = e.currentTarget;
    let newParams = {};
    let newModal = { ...initModal };
    newModal = {
      ...newModal,
      open: true,
      type: name,
    };
    if (name === 'add') {
      newModal = {
        ...newModal,
        modalTitle: 'DB Config 등록',
        confirmBtnTitle: '등록',
        params: {
          ...newModal.params,
          ...initParams,
        },
      };
    } else if (name === 'edit') {
      newParams = {
        sysId: data['SYS_ID'],
        cdId: data['CD_ID'],
        cdDetailId: data['CD_DETAIL_ID'],
      };
      detailDbSettingDetail(newParams)
        .then((response) => {
          const { data } = response.data;
          newModal = {
            ...newModal,
            modalTitle: '수정',
            confirmBtnTitle: '수정',
            params: {
              sysId: data[0]['SYS_ID'],
              cdId: data[0]['CD_ID'],
              cdDetailId: data[0]['CD_DETAIL_ID'],
              cdKey: data[0]['CD_KEY'],
              cdDesc: data[0]['CD_DESC'],
              orderSeq: data[0]['ORD_SEQ'],
            },
          };
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setModal(newModal);
        });
    } else if (name === 'delete') {
      newModal = {
        ...newModal,
        modalTitle: '삭제',
        confirmBtnTitle: '삭제',
        headerOpen: false,
        params: {
          sysId: data['SYS_ID'],
          cdId: data['CD_ID'],
          cdDetailId: data['CD_DETAIL_ID'],
        },
      };
    }
    if (name !== 'edit') {
      setModal(newModal);
    }
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    setModal(newModal);
  };
  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    let newParams = { ...modal.params };
    
    if (Object.keys(error).length === 0) {
      if (newParams['cdDetailId'] !== '') {
      } else {
        setError({
          cdDetailId: true,
        });
        return;
      }
    } else {
      return;
    }
    // 모달 수정시 빈 값에 대한 params 제거 for문
    // for (const key in newParams) {
    //   if (!newParams[key]) {
    //     delete newParams[key];
    //   }
    // } 
    if (modal.type === 'add') {
      addDeDetail(newParams)
        .then((response) => {
          const { message } = response.data;
          handleClickSnackbar({
            message: message,
            option: {
              type: 'success',
            },
          });
          setReFetch(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setReFetch(false);
        });
    } else if (modal.type === 'edit') {
      deDetailEdit(newParams)
        .then((response) => {
          const { message } = response.data;
          handleClickSnackbar({
            message: message,
            option: {
              type: 'success',
            },
          });
          setReFetch(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setReFetch(false);
        });
    } else if (modal.type === 'delete') {
      dbSettingDetailDelete({
        sysId: modal.params.sysId,
        cdId: modal.params.cdId,
        cdDetailId: modal.params.cdDetailId,
      })
        .then((response) => {
          const { message } = response.data;
          handleClickSnackbar({
            message: message,
            option: {
              type: 'success',
            },
          });
          setReFetch(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setReFetch(false);
        });
    }

    setModal({
      ...modal,
      open: false,
    });
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap loading={false}>
        <div>
          <NewButton
            type="modalBtn"
            name="add"
            onClick={handleModalOpen}
            disableRipple
          >
            {t('등록')}
          </NewButton>
        </div>
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={deDetailList}
        params={params}
        getParam={getParam}
        reFetch={reFetch}
        customized={customized}
        addColumnList={addColumnList}
        useExcel={false}
        useFetch={false}
        useTotal={false}
        rowsPerPage={5}
        useFullScreen={false}
      />
      <Modal
        open={modal.open}
        headerTitle={modal.modalTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        confirmOnClick={handleSubmit}
        useForm={modal.type === 'delete' ? false : true}
      >
        {(modal.type === 'add' || modal.type === 'edit') && (
          <>
            <tr>
              <th>{t('시스템아이디')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="sysId"
                  params={modal.params}
                  value={modal.params.sysId}
                  callBack={modalGetParam}
                  error={error.sysId}
                  disabled
                />
              </td>
            </tr>
            <tr>
              <th>{t('코드아이디')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="cdId"
                  params={modal.params}
                  value={modal.params.cdId}
                  callBack={modalGetParam}
                  error={error.cdId}
                  disabled
                />
              </td>
            </tr>
            <tr>
              <th>{t('* cddetailid')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="cdDetailId"
                  params={modal.params}
                  value={modal.params.cdDetailId}
                  callBack={modalGetParam}
                  error={error.cdDetailId}
                  disabled={modal.type === 'edit' ? true : undefined}
                />
              </td>
            </tr>
            <tr>
              <th>cdkey</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="cdKey"
                  params={modal.params}
                  value={modal.params.cdKey}
                  callBack={modalGetParam}
                />
              </td>
            </tr>
            <tr>
              <th>description</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="cdDesc"
                  params={modal.params}
                  value={modal.params.cdDesc}
                  callBack={modalGetParam}
                />
              </td>
            </tr>
            <tr>
              <th>orderseq</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="orderSeq"
                  params={modal.params}
                  value={modal.params.orderSeq}
                  callBack={modalGetParam}
                  helperText="숫자만 입력 가능합니다."
                />
              </td>
            </tr>
          </>
        )}
        {modal.type === 'delete' && (
          <>
            <p>
              {modal.params.cdDetailId === null
                ? '선택하신 항목을 '
                : modal.params.cdDetailId + ' 을(를) '}
              삭제하시겠습니까?
            </p>
          </>
        )}
      </Modal>
    </>
  );
};
export default withRouter(DbSettingDetail);
